enum OrigemEtapa {
    Venda = 1,
    ProducaoBases = 2,
}

export default OrigemEtapa;
